module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1073"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1052"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_1_In_Lin#page_1"
    }
  }, [_vm._v("In Line for the Exterminator ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1020"
  }, [_c('em', [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. Last Picked ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C1085"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Picked ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugar, Sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Balancing the Checkbook ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Open House, Science Fair Project ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Self-portrait with Cigarette ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slaughter Ball ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate for Football ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Vinyl ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cool ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FM Radio, 1971 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking It Up ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Detroit, 1972 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safety ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("At Dinner, My Father Informs Us He’s Been Laid Off ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elegy for the Sheik ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cyclone Fence, Detroit ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Petrified ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death Seat ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dreamscape ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_43",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Border Crossing ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abandoned, Detroit ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_I__Last#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sandy Had the Kind of Laugh ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1020"
  }, [_c('em', [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. Digger’s Body Shop ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C1085"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger, The Short Days ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger’s Lawn Care ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger’s Leak ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger Laid Off ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger’s Bad Reception ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger Gets a Checkup ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger Kills Time at the Clock Restaurant ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger’s Body Shop ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger Gives Away the Bride ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger Watches the Neighbors Move Out ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger Swallows the Worm ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger Loses His First Tooth ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger’s Donnybrook, Senior Softball ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger Turns in His ID ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_II__Digg#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Digger’s Property Assessment ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1020"
  }, [_c('em', [_c('strong', [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. The Shelter of My Father’s Coat ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "C1085"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Can’t Sleep ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American Cheese ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot Dog Variations ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pastime Lanes Lounge ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hooked ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Driving Past the County Jail ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbs and Blood ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_97",
      "id": "page_ix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Identity Theft ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arguing about Guns, Again ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Shadow ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breath for My Mother, August ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweating Bullets at “Sarah’s Hair Spot” ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunday Morning ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Recess ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outrage at the Laundromat ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Punching the Numbers ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allergic to Bullets ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1086"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_III__The#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shelter of My Father’s Coat ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1020"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_Acknowle#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0b627c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_Contents.vue
// module id = 69
// module chunks = 0